import React from 'react';

const CustomTick = ({ x, y, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <text x={0} y={0} dy={16} textAnchor="middle" className="chart__tick">
      {payload.value}
    </text>
  </g>
);

export default CustomTick;
